import { motoModelClient } from "../clients/motoModelClient"
import type {
  MotoModelResponseDto,
  CreateMotoModelDto,
  UpdateMotoModelDto,
  MotoModelListParams,
  MotoModelListResponseDto,
  DeleteMotoModelResponseDto,
} from "../types/motoModel.types"

/**
 * Moto Model Service
 * Business logic layer - handles API responses, errors, and side effects
 */
export const motoModelService = {
  /**
   * Get moto model by ID
   */
  getMotoModelById: async (id: string): Promise<MotoModelResponseDto> => {
    try {
      const model = await motoModelClient.getMotoModelById(id)
      return model
    } catch (error: any) {
      throw error
    }
  },

  /**
   * List moto models with filters
   */
  getMotoModels: async (params?: MotoModelListParams): Promise<MotoModelListResponseDto> => {
    try {
      const response = await motoModelClient.getMotoModels(params)
      return response
    } catch (error: any) {
      throw error
    }
  },

  /**
   * Create moto model
   */
  createMotoModel: async (data: CreateMotoModelDto): Promise<MotoModelResponseDto> => {
    try {
      const model = await motoModelClient.createMotoModel(data)
      return model
    } catch (error: any) {
      throw error
    }
  },

  /**
   * Update moto model
   */
  updateMotoModel: async (
    id: string,
    data: UpdateMotoModelDto
  ): Promise<MotoModelResponseDto> => {
    try {
      const model = await motoModelClient.updateMotoModel(id, data)
      return model
    } catch (error: any) {
      throw error
    }
  },

  /**
   * Delete moto model
   */
  deleteMotoModel: async (id: string): Promise<DeleteMotoModelResponseDto> => {
    try {
      const response = await motoModelClient.deleteMotoModel(id)
      return response
    } catch (error: any) {
      throw error
    }
  },
}

export default motoModelService

